import { FindADoctor } from '@ahc-digital/component-library';
import { S01FindADoctorProps } from './S01FindADoctor.types';
import { CreateFindADoctorModel } from './S01FindADoctor.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { useCustomSitecoreContext } from 'src/shared/useCustomSitecoreContext';
import { useEffect, useState } from 'react';
import { fetchSpecialityList } from 'src/shared/ReputationLocatorApi.service';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export const Default = (props?: S01FindADoctorProps): JSX.Element => {
  const context = useCustomSitecoreContext();
  const reputationDoctorSearchID = context?.reputationDoctorSearchID?.value;
  const [options, setOptions] = useState({});
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  useEffect(() => {
    async function fetchOptions() {
      try {
        const response = reputationDoctorSearchID
          ? await fetchSpecialityList(
              reputationDoctorSearchID,
              props?.fields?.FilterType?.value ?? ''
            )
          : {};
        setOptions(response);
      } catch (error) {
        console.error('Error fetching options:', error);
      }
    }
    fetchOptions();
  }, [reputationDoctorSearchID, props?.fields?.FilterType?.value]);

  const doctorSearchURL: string = context?.doctorSearchURL?.value ?? '';
  const googleMapEnvName = context?.envVariableNameForGoogleMapAPI?.value;
  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;
  return (
    <FindADoctor
      {...CreateFindADoctorModel(props, doctorSearchURL, googleMapEnvName ?? '', options)}
      className={translationClasses(props?.params)}
      data-component={marketingRenderingName}
    />
  );
};
